import React from "react";
import PropTypes from "prop-types";
import styles from "./EducationItem.css";

const EducationItem = ({ item }) => (
  <div className={[styles.EducationItem, styles.clearfix].join(" ")}>
    <div className={[styles.SchoolHeading, styles.clearfix].join(" ")}>
      <span className={styles.DegreeTitle}>
        <p>{item.degree}</p>
        <p className={styles.SchoolTitle}>{item.institution}</p>
      </span>
      <span className={styles.Timeline}>
        <p>{item.completedDate}</p>
      </span>
    </div>
  </div>
);

EducationItem.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired
};

export default EducationItem;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Education/EducationItem/EducationItem.js